export default "__VITE_ASSET__CEuEQLc$__"